import CalendarTab from './CalendarTab';

export default CalendarTab;
